// @flow

import React from 'react';
import styles from './searchBox.scss';

const searchIcnUrl = require('../../../assets/images/search_icn.svg');

type Props = {
  placeHolder?: string,
  onSearchValueChange: Function,
  resetSearchText: boolean,
  onKeyPress?: Function,
  maxLength?: string,
  minValue?: string,
  allowedInputKeys?: string
};

type State = {
  searchVal: string
};

class SearchBox extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      searchVal: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.resetSearchText !== this.props.resetSearchText) {
      this.setState({
        searchVal: ''
      });
    }
  }

  onChange(val) {
    this.setState(
      {
        searchVal: val
      },
      () => this.props.onSearchValueChange(val)
    );
  }

  onChangeHandler(val, target) {
    if (this.props.allowedInputKeys) {
      const allowedInput = this.props.allowedInputKeys;
      if (allowedInput === 'onlynumber') {
        if (!/^[0-9]*$/.test(val)) {
          // regex test for only number
          return;
        }
      } else if (allowedInput === 'onlytext') {
        if (!/^[a-zA-Z ]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'phoneNumber') {
        if (!/^[0-9]{0,10}$/.test(val)) {
          //regex for 10 digit phone number
          return;
        }
      } else if (allowedInput === 'alphaNumeric') {
        if (!/^[a-zA-Z0-9 ]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'onlyCapitalText') {
        if (!/^[A-Z]*$/.test(val)) {
          // regex test for only text
          return;
        }
      } else if (allowedInput === 'decimalnumber') {
        if (!/^(\d*\.?\d{0,9}|\.\d{1,9})$/.test(val)) {
          return;
        }
      } else if (allowedInput === 'numericcoma') {
        if (!/^[\d{1,10}(,\d{1,10})]*$/.test(val)) {
          return;
        }
      } else if (allowedInput === 'validCn') {
        if (
          !/^[\d]{0,10}(\-[\d]{0,10}){0,1}([,][\d]{0,10}(\-[\d]{0,10}){0,1})*$/.test(
            val
          )
        ) {
          return;
        }
      }
    }

    this.setState(
      {
        value:
          this.props.type === 'number' && this.props.maxLength
            ? val.slice(0, Number(this.props.maxLength))
            : val
      },
      () => {
        this.onChange(val);
      }
    );
  }

  handleKeyPress(e) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(e);
    }
  }

  render() {
    return (
      <div className={`${styles.searchBoxWrapper} search-box-wrapper`}>
        <div className={`${styles.searchIcnWrapper} search-icn-wrapper`}>
          <img
            className={`${styles.searchIcn} search-icn`}
            src={searchIcnUrl}
            alt=""
          />
        </div>
        <input
          className={`${styles.searchBoxInput} search-box-input`}
          placeholder={this.props.placeHolder || 'Search'}
          onChange={e => this.onChangeHandler(e.target.value, e.target)}
          value={this.state.searchVal}
          style={{ background: this.props.disabled ? '#cacccd' : '' }}
          disabled={this.props.disabled}
          onKeyPress={e => this.handleKeyPress(e)}
          maxLength={this.props.maxLength}
          min={this.props.minValue}
        />
      </div>
    );
  }
}

export default SearchBox;
